import { IPersonBadge, IProduct } from "../../../../../../common/types";
import { InfoIconsBar } from "../infoIconsBar/InfoIconsBar";
//@ts-ignore
import { BadgeOrdersModal, EventEdition } from "@reedexpo/mercury-badge-manager-components";
import { useMemo, useState } from "react";
import { BadgeOrder, CountryItem } from "../../../../../../redux/types";
import i18n from "../../../../../../common/translations";
import { muiTypographyTheme } from "./utils/theme";
import { ThemeProvider } from "@mui/material";

type Props = {
  badge: IPersonBadge;
  orders: BadgeOrder[];
  products: IProduct[];
  badges: IPersonBadge[];
  countries: CountryItem[];
  eventEdition: EventEdition;
};

export const BadgeStatusBar = ({ badge, orders, products, badges, countries, eventEdition }: Props) => {
  const [selectedBadge, setSelectedBadge] = useState<IPersonBadge | null>(null);

  const ordersLength = useMemo(() => {
    return orders.filter((order: BadgeOrder) => order.chargedItemPrice && order.badgeId === badge.id).length;
  }, [orders]);

  const handleBadgeOrdersClose = () => {
    setSelectedBadge(null);
  };

  return (
    <>
      <InfoIconsBar ordersCount={ordersLength} badge={badge} setSelectedBadge={setSelectedBadge} />
      {selectedBadge && (
        <ThemeProvider theme={muiTypographyTheme}>
          <BadgeOrdersModal
            eventEdition={eventEdition}
            countries={countries}
            data-testid="badge-status-bar-modal"
            isOpen={Boolean(selectedBadge)}
            handleCloseModal={handleBadgeOrdersClose}
            products={products}
            badges={badges}
            currentBadge={selectedBadge}
            orders={orders}
            environment={process.env.REACT_APP_ENVIRONMENT!}
            locale={i18n.language}
          />
        </ThemeProvider>
      )}
    </>
  );
};
